import { Buttons } from '../../modals/classes/buttons';

export class ActiveModalButtons extends Buttons {

    constructor() {
        super();
    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/modals/classes/active-modal-buttons.ts